import {
  convertDotcmsResponseToRecord,
  convertDotcmsString,
} from './converters-from-dotcms';
import type { IBaseObjectData } from './dotcms-base-object';
import type { IArticlesPreviewModuleData } from './resources/dotcms-module-articles-preview';
import { ArticlesPreviewModuleGqlHelper } from './resources/dotcms-module-articles-preview';
import type { IModuleWithBannerBasedOnEnrollmentStatusData } from './dotcms-module-with-banner-based-on-enrollment-status';
import { ModuleWithBannerBasedOnEnrollmentStatusGqlHelper } from './dotcms-module-with-banner-based-on-enrollment-status';
import type { IModuleWithImageData } from './dotcms-module-with-image';
import { ModuleWithImageGqlHelper } from './dotcms-module-with-image';
import type { IPopoutData } from './dotcms-popout';
import { PopoutGqlHelper } from './dotcms-popout';
import { buildGqlFieldsQuery } from './gql-builders';
import type { IGqlHelper } from './gql-helper';

export type IHomePageData = IBaseObjectData & {
  pageDescription: string;
  welcomeModule?: IModuleWithImageData;
  welcomeModuleEsppOnly?: IModuleWithImageData;
  learnMorePopout?: IPopoutData;
  whatIsEsppModule?: IModuleWithImageData;
  whatIsEsppModuleEsppOnly?: IModuleWithImageData;
  howDoesItWorkModule?: IModuleWithImageData;
  howDoesItWorkModuleEsppOnly?: IModuleWithImageData;
  reachMoreModule?: IModuleWithImageData;
  richResourcesModule?: IArticlesPreviewModuleData;
  richResourcesModuleEsppOnly?: IArticlesPreviewModuleData;
  readyToEnrollModule?: IModuleWithBannerBasedOnEnrollmentStatusData;
};

export const HomePageGqlHelper: IGqlHelper<IHomePageData> = {
  contentTypeName: 'HomePage',
  gqlFieldsQuery: `
    pageDescription
    welcomeModule { ${buildGqlFieldsQuery(ModuleWithImageGqlHelper)} }
    welcomeModuleEsppOnly { ${buildGqlFieldsQuery(ModuleWithImageGqlHelper)} }
    learnMorePopout { ${buildGqlFieldsQuery(PopoutGqlHelper)} }
    whatIsEsppModule { ${buildGqlFieldsQuery(ModuleWithImageGqlHelper)} }
    whatIsEsppModuleEsppOnly { ${buildGqlFieldsQuery(
    ModuleWithImageGqlHelper,
  )} }
    howDoesItWorkModule { ${buildGqlFieldsQuery(ModuleWithImageGqlHelper)} }
    howDoesItWorkModuleEsppOnly { ${buildGqlFieldsQuery(
    ModuleWithImageGqlHelper,
  )} }
    reachMoreModule { ${buildGqlFieldsQuery(ModuleWithImageGqlHelper)} }
    richResourcesModule { ${buildGqlFieldsQuery(
    ArticlesPreviewModuleGqlHelper,
  )} }
    richResourcesModuleEsppOnly { ${buildGqlFieldsQuery(
    ArticlesPreviewModuleGqlHelper,
  )} }
    readyToEnrollModule { ${buildGqlFieldsQuery(
    ModuleWithBannerBasedOnEnrollmentStatusGqlHelper,
  )} }
  `,
  processGqlData: (gqlResponse: unknown) => {
    if (!gqlResponse) {
      return undefined;
    }

    const {
      pageDescription,
      welcomeModule,
      welcomeModuleEsppOnly,
      learnMorePopout,
      whatIsEsppModule,
      whatIsEsppModuleEsppOnly,
      howDoesItWorkModule,
      howDoesItWorkModuleEsppOnly,
      reachMoreModule,
      richResourcesModule,
      richResourcesModuleEsppOnly,
      readyToEnrollModule,
    } = convertDotcmsResponseToRecord(gqlResponse);

    return {
      pageDescription: convertDotcmsString(pageDescription ?? '') ?? '',
      welcomeModule: ModuleWithImageGqlHelper.processGqlData(welcomeModule),
      welcomeModuleEsppOnly: ModuleWithImageGqlHelper.processGqlData(
        welcomeModuleEsppOnly,
      ),
      learnMorePopout: PopoutGqlHelper.processGqlData(learnMorePopout),
      whatIsEsppModule:
        ModuleWithImageGqlHelper.processGqlData(whatIsEsppModule),
      whatIsEsppModuleEsppOnly: ModuleWithImageGqlHelper.processGqlData(
        whatIsEsppModuleEsppOnly,
      ),
      howDoesItWorkModule:
        ModuleWithImageGqlHelper.processGqlData(howDoesItWorkModule),
      howDoesItWorkModuleEsppOnly: ModuleWithImageGqlHelper.processGqlData(
        howDoesItWorkModuleEsppOnly,
      ),
      reachMoreModule: ModuleWithImageGqlHelper.processGqlData(reachMoreModule),
      richResourcesModule:
        ArticlesPreviewModuleGqlHelper.processGqlData(richResourcesModule),
      richResourcesModuleEsppOnly:
        ArticlesPreviewModuleGqlHelper.processGqlData(
          richResourcesModuleEsppOnly,
        ),
      readyToEnrollModule:
        ModuleWithBannerBasedOnEnrollmentStatusGqlHelper.processGqlData(
          readyToEnrollModule,
        ),
    };
  },
};
